<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <div class="col-md-12">
        <Header pageTitle="Edit Profile" class="card-container"></Header>
        <form @submit.prevent="updateProfile">
          <div class="row">
            <div class="col-md-6">
              <fieldset>
                <legend>Account Information</legend>

                <div class="account_information_grid">
                  <div>

                    <label for="FirstName">First Name</label>
                    <base-input
                      type="text"
                      id="FirstName"
                      placeholder="First Name"
                      v-model="user.firstName"
                      :disabled="isPartnerAccount"
                      addon-left-icon="tim-icons icon-single-02"
                    ></base-input>
                  </div>
                  <div>
                    <label for="MiddleName">Middle Name</label>
                    <base-input
                      id="MiddleName"
                      v-model="user.middleName"
                      placeholder="Middle Name"
                      :disabled="isPartnerAccount"
                      addon-left-icon="tim-icons icon-single-02"
                    ></base-input>
                  </div>
                  <div>
                    <label for="LastName">Last Name</label>
                    <base-input
                      type="text"
                      id="LastName"
                      placeholder="Last Name"
                      v-model="user.lastName"
                      :disabled="isPartnerAccount"
                      addon-left-icon="tim-icons icon-single-02"
                    ></base-input>
                  </div>
                  <div>
                    <label for="Title">Title</label>
                    <base-input
                      id="Title"
                      :error="getError('title')"
                      v-model="user.title"
                      name="title"
                      type="text"
                      placeholder="Title"
                      addon-left-icon="tim-icons icon-badge"
                    ></base-input>
                  </div>
                  <div>
                    <label for="PhoneNumber">Phone Number</label>
                    <base-input
                      id="PhoneNumber"
                      :error="getError('phoneNumber')"
                      v-model="user.phoneNumber"
                      name="phonenumber"
                      type="text"
                      placeholder="Phone number"
                      addon-left-icon="tim-icons icon-mobile"
                    ></base-input>
                  </div>
                  <div>
                    <label for="Email">Email</label>
                    <base-input
                      id="Email"
                      disabled
                      v-model="user.email"
                      name="email"
                      placeholder="Email"
                      addon-left-icon="tim-icons icon-email-85"
                    ></base-input>
                  </div>
                  
                  <div v-if="isPartner">
                    <base-input  label="Country" :disabled="true" v-model="userCountries"></base-input>
                  </div>
                  <div v-else>
                    <label  for="Organization">Organization</label>
                    <base-input
                      id="Organization"
                      :error="getError('organization')"
                    >
                      <treeselect
                        v-model="user.organizationId"
                        disabled
                        class="select-primary"
                        name="organization"
                        :options="jointStaffOrganizations"
                      />
                 
                    </base-input>
                  </div>
                  <div>
                    <label for="Status">Status</label>
                    <base-input
                      id="Status"
                      disabled
                      v-model="user.approvalStatusName"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <!-- <label for="ApprovedBy">Approver</label> -->
                    <base-input
                      disabled
                      v-model="this.user.approverNameLabel"
                      label="Approver"
                    >
                    </base-input>
                    <!-- <base-input id="ApprovedBy" :error="getError('approve')">
                      <v-select
                        v-model="user.approverId"
                        disabled
                        name="approve"
                        :reduce="(user) => user.id"
                        label="name"
                        :options="sponsorUsers"
                        placeholder="Select one"
                      ></v-select>
                    </base-input> -->
                  </div>
                  <div class="col-md-6">
                    <label for="ApprovedBy">{{isPartnerAccount ? 'Partner Nation Manager' : "Sponsor"}}</label>
                    <base-input id="ApprovedBy" :error="getError('approve')">
                      <v-select
                        v-model="user.sponsorId"
                        name="approve"
                        :disabled="true"
                        :reduce="(user) => user.id"
                        label="name"
                        :options="sponsorUsers"
                        placeholder="Select one"
                      ></v-select>
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label for="Roles">Roles</label>
                    <base-input id="Roles" :error="getError('roles')">
                      <v-select
                        disabled
                        v-model="user.roles"
                        name="roles"
                        multiple
                        :reduce="(role) => role.name"
                        label="name"
                        :options="roles"
                        placeholder="Select one"
                      ></v-select>
                    </base-input>
                  </div>
                </div>
              </fieldset>
              <base-button
                type="primary"
                class="btn-fill"
                @click="updateProfile()"
                ><i class="tim-icons icon-pencil"></i> Save</base-button
              >
            </div>
            <div class="col-md-6">
              <fieldset>
                <legend>Documentation</legend>
                <user-upload :type="'personal'"></user-upload>
              </fieldset>
              <br />
              <fieldset>
                <div class="content_padding_top_small date">
                  <label for="signatureDate">Account Expiration</label>
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    content="Contact Sponsor to update expiration date"
                  >
                  <el-date-picker
                    id="signatureDate"
                    type="date"
                    v-model="user.expirationDate"
                    format="dd-MMMM-yyyy"
                    data-vv-as="Account Expiration"
                    name="dateSigned"
                    :disabled="true"
                  >
                  </el-date-picker>
                </el-tooltip>
                </div>
              </fieldset>
              <hr />
              <fieldset>
                <legend>Other Settings</legend>
                <base-button
                  type="dark"
                  class="btn-fill"
                  @click="changePassword()"
                  ><i class="tim-icons icon-key-25"></i> Change
                  Password</base-button
                >
                <base-button v-if="!isPartnerAccount" type="dark" :disabled="user.isCacRegistered" class="btn-fill" @click="registerCac()"
                  ><i class="tim-icons icon-badge"></i> {{ user.isCacRegistered ?  'CAC Already Registered' : 'Register CAC' }}</base-button
                >
              </fieldset>
              <hr v-if="isVisible"/>

              <fieldset v-if="isVisible">
                <legend >Partner Nations Managed</legend>
                <el-card disabled class="box-card" shadow="always">
                  <div
                    style="text-align: left"
                    v-for="i in countryIds"
                    :key="i.id"
                    class="text item"
                    :class="i.isPartnerNationApproval ? 'isApproved' : 'isNotApproved'"
                  >
                    <div class="text">
                      <i class="tim-icons icon-world"></i> {{ i.name }} 
                      <span v-if="!i.isPartnerNationApproval">
                        (Not Active)
                      </span>
                    </div>
                  </div>
                </el-card>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </div>
  </center>
</template>

<script>
import UserUpload from "./documents/UserDocuments";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import { Select, Option, Card } from "element-ui";
import Header from "@/components/App/Header.vue";
import Util from "@/util/util";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    UserUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Card.name]: Card,
    Treeselect,
    Header,
  },
  data() {
    return {
      user: {},
      isVisible: false,
      countryIds: [],

    };
  },
  watch: {
    user(now) {
      if(now != undefined && now.roles != undefined) {
        let userRoles  = now.roles;
        if(userRoles != undefined){
          if(userRoles.includes('PartnerNationManager')){
            this.getSelectedCountries();
            this.isVisible = true;
          }else{
            this.isVisible = false
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      roles: "role/roles",
      approvalStatuses: "approvalStatus/approvalStatuses",
      sponsorUsers: "users/sponsorUsers",
      isPartnerAccount: "authentication/isPartnerAccount",
      isPNManager: "authentication/isPNManager",
      isOUSD: "authentication/isOUSD"
    }),
    isPartner() {
      return this.user && this.user.roleString == Util.PARTNER_NATION;
    },
    userCountries(){
      var str = '';
      if(this.user.countriesToManage){
        if(this.user.countriesToManage.length > 0)
        str= this.user.countriesToManage[0].name;
        return str;
      } 
     }
  },
  async mounted() {
    this.$loaderApp.addRequest();
    await this.getUser();
    await this.getJointStaffOrganizations();
    await this.getRoles();
    await this.getApprovalStatuses();
    await this.getSponsorUsers();
    this.$loaderApp.completeRequest();
  },
  methods: {
    ...mapActions({
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getRoles: "role/getRoles",
      getApprovalStatuses: "approvalStatus/getApprovalStatuses",
      getSponsorUsers: "users/getSponsorUsers",
      cacRegister: "authentication/cac_register",
    }),
    getSelectedCountries(){
      if(this.user.countriesToManage){
        var countries = this.user.countriesToManage;
        let temp = countries.map(a => { 
          var ret = {
            id: a.countryId,
            name: a.name,
            isPartnerNationApproval: (a.isPartnerNationApproval) ? true : false
          };
          return ret;
        });

        var result = [];
        var approved = temp.filter(c => c.isPartnerNationApproval == true);
        var notApproved = temp.filter(c => !c.isPartnerNationApproval);
        result.push(...approved, ...notApproved);
        this.countryIds = result;
      }
    },
    registerCac() {
      this.cacRegister().then((response) => {
        this.$toast.success(response.data);
      }).catch((errorMessage) => {
          this.$toast.error(errorMessage.response.data);
        });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    changePassword() {
      this.$router.push("/Account/ChangePassword");
    },
    dfs(obj, targetId) {
      if (obj.id === targetId) {
        return obj;
      }

      if (obj.children) {
        for (let children of obj.children) {
          let check = this.dfs(children, targetId);
          if (check) {
            return check;
          }
        }
      }
      return null;
    },
    validateOrganization(organizationId) {
      let ctx = this;
      let result = null;

      for (let organization of ctx.jointStaffOrganizations) {
        result = this.dfs(organization, organizationId);
        if (result) {
          break;
        }
      }
      return (result != null) ? result.id : 48;
    },
    getUser() {
      let ctx = this;
      this.getJointStaffOrganizations().then((res) => {
        ctx.axios.get(`api/applicationusers/email`).then((response) => {
          //Load the data
          ctx.user = response.data;
          ctx.user.organizationId = ctx.validateOrganization(
            ctx.user.organizationId
          );
        });
      });
    },
    updateProfile() {
      let formData = {
        id: this.user.id,
        email: this.user.email,
        firstName: this.user.firstName,
        middleName: this.user.middleName,
        lastName: this.user.lastName,
        title: this.user.title,
        phoneNumber: this.user.phoneNumber,
      };

      this.axios
        .post("api/applicationusers/profile", formData, { config:{ showToast: true, message: "User Information Details Successfully Saved!!"}})
        .then((response))
        .catch((error) => {
          new swal({
            title: "Error!",
            text: `${error.response.data}`,
            icon: "error",
            confirmButtonColor: "#10b45a",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.account_information_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}
.box-card {
    width: 280px;
    height: 150px;
    overflow:auto;    
}
.text {
  font-size: 12px !important;
  padding-top: 3px;
}
.isApproved {
  color: #048000;
  .tim-icons {
    color: green;
  }
}
.isNotApproved {
  color: grey;
}

.date {
  width: 50%
}

@media only screen and (max-width: 1200px) {
  .account_information_grid {
    grid-template-columns: 1fr;
  }
}
</style>
